import type { Components, Theme } from '@mui/material';

export const MuiAccordion: Components<Theme>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
    elevation: 0,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.spacing(1.5),
      overflow: 'hidden',

      '&::before': { display: 'none' },
      '&:first-of-type': { borderRadius: theme.spacing(1.5) },
      '&:last-of-type': { borderRadius: theme.spacing(1.5) },
      '&.Mui-expanded': { borderRadius: theme.spacing(1.5) },
    }),
  },
};

export const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0, 2),
      minHeight: 56,
      '&.Mui-expanded': { minHeight: 56 },
    }),
  },
};

export const MuiAccordionDetails: Components<Theme>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
    }),
  },
};
